module.exports = __webpack_public_path__ + "img/cog-lg.cf09538b.png";